import { render } from "./Course.vue?vue&type=template&id=46dbfaf8&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=46dbfaf8&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-46dbfaf8"

export default script